export default __webpack_public_path__ + "static/media/a14.7082a10b.jpg";